import parseText from '../text-msg-parser';

import linkifyIt from 'linkify-it';
import { xss } from '@meiqia/utils';

const linkifyJs = linkifyIt();
const { emojiToEmpty, replaceBrToEmpty } = parseText;
// 忽略的内容需要替换为一个不被计入线索的特性分隔符
const splitClueString = ';';

const parseUrl = string => {
  if (!string) {
    return {
      result: '',
      clue: []
    };
  }
  let clue = [];
  let result = '';
  const matchList = linkifyJs.match(string);
  if (Array.isArray(matchList) && matchList.length > 0) {
    const totalLength = string.length;
    let latestIndex = 0;
    matchList.forEach(val => {
      const { index, text, lastIndex } = val;
      clue.push(text);
      if (latestIndex === index) {
        result = `${result}${splitClueString}`;
      } else {
        result = `${result}${string.substring(latestIndex, index)}${splitClueString}`;
      }
      latestIndex = lastIndex;
    });
    // 拼接最后的字符串
    if (latestIndex < totalLength - 1) {
      result = `${result}${string.substring(latestIndex, totalLength)}`;
    }
  } else {
    result = string;
  }
  return { result, clue };
};

const getClue = string => {
  if (!string && typeof string !== 'string') {
    return '';
  }
  let restString = string;
  const { result, clue: clueUrl } = parseUrl(string);
  try {
    restString = result;
    restString = replaceBrToEmpty(restString, { replaceContent: splitClueString });
    restString = emojiToEmpty(restString, { replaceContent: splitClueString });
    restString = xss(restString);
  } catch (e) {
    console.log('getClueError--------------------->', e);
  }
  const clueCustom = restString.match(/([0-9-_+()\s+]{5,20}|[a-zA-Z0-9-_]{5,20})/g) || [];
  return [...clueUrl, ...clueCustom];
};

export default getClue;
